import { LocationState } from '../store/user/types';

type LatLngLiteral = {
  lat: number;
  lng: number;
};
export function calculateDistanceInMeters(
  pointA: LocationState | undefined,
  pointB: LocationState | undefined
): number {
  const R = 6371e3; // earth radius in meters
  const φ1 = Number(pointA?.lat) * (Math.PI / 180);
  const φ2 = Number(pointB?.lat) * (Math.PI / 180);
  const Δφ = (Number(pointB?.lat) - Number(pointA?.lat)) * (Math.PI / 180);
  const Δλ = (Number(pointB?.lng) - Number(pointA?.lng)) * (Math.PI / 180);

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * (Math.sin(Δλ / 2) * Math.sin(Δλ / 2));

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c;

  return distance;
}
